import api from "api";
import { IGetTransactionsQueryParams, IRefundTransactionQueryParams } from "types/transaction";

const getTransactions = (queryParams: IGetTransactionsQueryParams) => {

  const { pageIndex, pageSize, sortBy, search, carWashIds } = queryParams

  let query = `pageIndex=${pageIndex}&pageSize=${pageSize}&sortBy=${sortBy}`

  if(search) {
    query += `&search=${search}`
  }

  if(carWashIds !== undefined && carWashIds.length > 0) {
    carWashIds.forEach(( id: number, i: number ) => {
      query += `&carWashIds[${i}]=${id}`
    })
  }

  return api.get(`/ecommerce/getAdminBankTransactions?${query}`)
}

const refundTransaction = (queryParams: IRefundTransactionQueryParams) => {

  const { paymentId, returnAmount, returnFullAmount } = queryParams

  const query = `paymentId=${paymentId}&returnAmount=${returnAmount}&returnFullAmount=${returnFullAmount}`

  return api.post(`/ecommerce/refundBankTransaction?${query}`)
}

export default { getTransactions, refundTransaction }